

/** @type {import('./syntax')} */
module.exports = SyntaxError;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/syntax.js
// module id = ../node_modules/es-errors/syntax.js
// module chunks = 0